import Components from "../components";

class Sticky extends Components.Base {
  initialize() {
    this.stickyEl = this.$el[0];
    this.scrollPaddingTop = this.stickyEl.clientHeight + 1; // bottom border of 1px
    this.maxScrollY = document.body.offsetHeight - window.innerHeight;

    // Add scroll offset (subnav height) to the page
    document.documentElement.style = `scroll-padding-top: ${this.scrollPaddingTop}px`;
  }

  bind() {
    // Observe the sticky nav and add .is-sticky class
    this.stickyObserver = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
      { threshold: [1] },
    );
    this.stickyObserver.observe(this.stickyEl);

    // Custom scrollspy implementation
    const targets = Array.from(document.querySelectorAll(".scrollspy-target"));

    this.handleNavLinksClick();
    this.spyTargets(targets);

    this.abortController = new AbortController();
    document.addEventListener(
      "scroll",
      () => {
        this.maxScrollY = document.body.offsetHeight - window.innerHeight;
        this.spyTargets(targets);
      },
      { signal: this.abortController.signal },
    );
  }

  unbind() {
    this.stickyObserver.unobserve(this.$el[0]);
    this.abortController.abort();
  }

  spyTargets(targets) {
    const navLinks = this.getNavLinks();

    targets.forEach((targetEl) => {
      const hash = `#${targetEl.id}`;
      const navLink = navLinks.find((el) => el.hash === hash);
      const [topOffset, bottomOffset] = this.getElementOffsets(targetEl);
      const a = targetEl.offsetTop - this.scrollPaddingTop - topOffset - 1; // bottom border of 1px
      const b =
        a + targetEl.offsetHeight + this.scrollPaddingTop - bottomOffset;

      if (!navLink) return;

      if (window.scrollY >= a && window.scrollY < b) {
        this.activateNavLink(navLinks, navLink, targetEl);
      } else {
        navLink.classList.remove("active");
      }
    });

    // Activate the first nav link if the page is scrolled before the first section/target
    if (window.scrollY <= targets[0].offsetTop) {
      this.activateNavLink(navLinks, navLinks[0], targets[0]);
    }

    // Activate the last nav link if the page scroll reaches the bottom
    if (window.scrollY === this.maxScrollY) {
      this.activateNavLink(
        navLinks,
        navLinks[navLinks.length - 1],
        targets[targets.length - 1],
      );
    }
  }

  getNavLinks() {
    return Array.from(this.stickyEl.querySelectorAll(".c-subnav .nav-link"));
  }

  handleNavLinksClick() {
    const navLinks = this.getNavLinks();

    navLinks.forEach((navLink) => {
      navLink.addEventListener("click", (e) => {
        e.preventDefault();

        const targetId = e.currentTarget.hash.split("#")[1];
        const targetEl = document.getElementById(targetId);
        targetEl.scrollIntoView();

        window.location.hash = targetId;
      });
    });
  }

  getElementOffsets(el) {
    const cs = getComputedStyle(el);
    const topOffset =
      parseInt(cs.getPropertyValue("margin-top")) +
      parseInt(cs.getPropertyValue("padding-top"));
    const bottomOffset =
      parseInt(cs.getPropertyValue("margin-bottom")) +
      parseInt(cs.getPropertyValue("padding-bottom"));

    return [topOffset, bottomOffset];
  }

  activateNavLink(navLinks, activatedNavLink, targetEl) {
    const hash = `#${targetEl.id}`;

    navLinks.forEach((el) => el.classList.remove("active"));
    activatedNavLink.classList.add("active");
    this.updateHREFs(hash);
  }

  updateHREFs(hash) {
    Array.from(this.$el.find(".c-notice-pager a")).forEach((link) =>
      link.setAttribute("href", link.href.split("#")[0] + hash),
    );
  }
}

Components.collection.register({ selector: ".c-sticky", klass: Sticky });
